<template>
  <div class="arrange-mode-toolbar"> 
    <arrange-mode-controls :keyFramesTimes="getKeyFramesTimes(tagFilter)"/>
    <waypoint-navigator @selectWaypoint="onSelectWaypoint" :filteredTags="filteredTags"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import waypointNavigator from '../../core/waypointNavigator'
import arrangeModeControls from './arrangeModeControls'
import { getFilter } from '../../../utils/filters'

export default {
  name: 'arrangeModeToolbar',

  components: {
    'waypoint-navigator': waypointNavigator,
    'arrange-mode-controls': arrangeModeControls
  },

  computed: {
    ...mapGetters(['getKeyFramesTimes', 'currentTime', 'getAllTagsFiltered']),

    tagFilter: function () {
      return getFilter('1')
    },

    filteredTags: function () {
      return this.getAllTagsFiltered(this.tagFilter)
    }
  },

  methods: {
    ...mapMutations(['setPlayerTime', 'resetSelection', 'clearKeyFrame', 'updateKeyFrame']),

    onSelectWaypoint: function (waypoint) {
      if (waypoint.time.toFixed(2) !== this.currentTime.toFixed(2)) {
        this.clearKeyFrame()
        this.resetSelection()
        this.setPlayerTime(waypoint.time)
      }

      this.updateKeyFrame(waypoint)
    }
  }
}
</script>
